<template>
  <a class="LinkCardBlock no-underline color-inherit mb-3"
     :href="href">
    <div class="LinkCardBlock--left primary">
      <img :src="iconUrl"
           alt="Icône lien">
    </div>
    <div class="LinkCardBlock--right">
      <div class="LinkCardBlock--label">{{label}}</div>
      <div class="LinkCardBlock--href">{{domainFromHref}}</div>
    </div>
  </a>
</template>

<script>
  export default {
    computed: {
      domainFromHref () {
        return (new URL(this.href)).hostname
      }
    },

    props: {
      href: {
        type: String,
        required: true
      },
      iconUrl: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .LinkCardBlock {
    display: flex;
    min-height: 70px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .LinkCardBlock--left {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 70px;
  }

  .LinkCardBlock--right {
    padding: 11px;
  }

  .LinkCardBlock--label {
    font-size: 18px;
    font-weight: 700;
  }

  .LinkCardBlock--href {
    color: #909090;
    font-size: 14px;
  }
</style>
